module.exports = __webpack_public_path__ + "static/img/AR_zhiliang02.4e98d05.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/AboutUs/AR/AR_zhiliang02.jpg
// module id = WgTe
// module chunks = 12